// extracted by mini-css-extract-plugin
export default {"connecting":"H5IsR4QK4rUv8XyHNlBy","waiting":"mNu2lyb5CRMjUaaDSthX","duration":"NVL50CdJ6RW_ZTZad4IF"};